import React from "react";
import { MessageCircle } from "lucide-react";

export default function WhatsAppWidget() {
  const phone = "16616664529"; // Web Vantage WhatsApp business number
  const text = encodeURIComponent("Hi Web Vantage, I'd like to discuss a project.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-widget"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_-8px_rgba(37,211,102,0.7)] transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle className="h-7 w-7" fill="white" strokeWidth={0} />
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-40" />
    </a>
  );
}
